// LedgersDialog.tsx — Ledger beam pockets (lbvar + llvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import type { LbVar } from '../types/panelvar';

export default function LedgersDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [lb, setLb] = useState<LbVar>(panel ? { ...panel.lbvar } : { enabled: false, y: 0, depth: 0, width: 0, mark: 'LB-1' });
  if (!panel) return null;

  function set(key: keyof LbVar, value: string | number | boolean) {
    setLb(prev => ({ ...prev, [key]: value }));
  }

  return (
    <DialogBase title="Ledgers" onOk={() => updatePanel(panel.id, { lbvar: lb })}>
      <div className="dialog-section">
        <div className="dialog-row">
          <label className="dialog-label">Enabled</label>
          <input
            type="checkbox"
            checked={lb.enabled ?? false}
            onChange={e => set('enabled', e.target.checked)}
          />
        </div>
        <div className="dialog-row">
          <label className="dialog-label">Mark</label>
          <input
            className="dialog-input sm"
            type="text"
            value={lb.mark}
            onChange={e => set('mark', e.target.value)}
          />
        </div>
        {(['y', 'depth', 'width'] as (keyof LbVar)[]).map(key => (
          <div className="dialog-row" key={key as string}>
            <label className="dialog-label">{String(key)}</label>
            <input
              className="dialog-input sm"
              type="number"
              value={lb[key] as number}
              step={0.5}
              onChange={e => set(key, parseFloat(e.target.value))}
            />
            <span className="dialog-unit">"</span>
          </div>
        ))}
      </div>
    </DialogBase>
  );
}

